module.exports = __webpack_public_path__ + "img/6b913dc.webp";